export const ROUTE_URLS = {
  ORDERS: 'orders',
  HISTORY: 'history',
  PROCESS: 'orders/:id',
  CONTACTUS: 'contact-us',
  HISTORY_DETAILS: 'history/:id',
  SEARCH: 'search',
  LOGIN: 'login',
}
